module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.enableNotificationsButtons) ? _c('v-layout', {
    on: {
      "click": _vm.askForNotificationPermission
    }
  }, [_c('v-flex', {
    on: {
      "click": _vm.toggleNotifications
    }
  }, [_c('div', {
    staticClass: "pb-2 h2-dark",
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Notifications")]), _vm._v(" "), _c('div', {
    staticClass: "dark-window pa-3 center",
    staticStyle: {
      "margin-top": "-18px",
      "overflow": "hidden",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    class: {
      'switch-on': _vm.user.notifications, 'switch-off': !_vm.user.notifications
    }
  })])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d31a2ec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications.vue
// module id = 718
// module chunks = 24